// extracted by mini-css-extract-plugin
module.exports = {"optionText":"_2Sc0dl","buttonContainer":"_1pevxf","option":"_1CBYvs","button":"ErxuL9","row":"_227LUs","shine-lines":"_1T6vV_"};